module.exports = __webpack_public_path__ + "static/img/b105.02028173.png";